/**
 * List of capital call types
 */

export enum CapitalCallType {
    EquityCall = 'Equity Call',
    BridgeLoan = 'Bridge Loan',
    LetterOfCredit = 'Letter Of Credit'
}